import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { StyledApplication } from './styles';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { Tabs, Form, Button, Select, Tooltip, message } from 'antd';
import { EditOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import {
  API_DEVICE,
  API_PARAMETER,
  API_DEVICETYPE,
  API_DOWNLOAD,
  TOPIC,
  IPAddress,
  API_RUBUSMASTERS
} from '../../../commons/api';

const { Option } = Select;
const { TabPane } = Tabs;

const TopicList = ({ translationCache }) => {
  const [disableDetails, setDisableDetails] = useState(true);
  const [disabledDropdown, setDisabledDropdown] = useState(false);
  const [datasource, setDatasource] = useState([]);
  const [formObject, setFormObject] = useState({});
  const [formObjectBulk, setFormObjectBulk] = useState({});
  const [deviceType, setDeviceType] = useState([]);
  const [AssetTypeList, setAssetTypeList] = useState([]);
  const [AssetParametersList, setAssetParametersList] = useState([]);
  const [device, setDevice] = useState([]);
  const [ParameterList, setParameterList] = useState([]);
  const [activeKey, setActiveKey] = useState('List');
  const [activeDetails, setActiveDetails] = useState('1');
  const [topicId, setTopicId] = useState('');
  const [selectedType, setSelectedType] = useState(null);
  const [selectedAsset, setSelectedAsset] = useState('');
  const [deviceCode, setDeviceCode] = useState('');
  // const [resultFile, setResultFile] = useState('');
  const [file, setFile] = useState(null);
  
  const hRef = useRef();
  const hForm = useRef();
  const hFile = useRef();

  useEffect(() => {
    getMasterList();
    DeviceTypeApi();
    AssetTypeApi();
  }, []);

  const DeviceTypeApi = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const type = {
      method: 'GET',
      url: `${API_DEVICETYPE.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(type)
      .then((response) => {
        setDeviceType(response.data);
      })
      .catch(() => {});
  };

  const AssetTypeApi = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const type = {
      method: 'GET',
      url: `${API_RUBUSMASTERS.AssetTypesGET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(type)
      .then((response) => {
        setAssetTypeList(response.data);
      })
      .catch(() => {});
  };

  const DeviceApi = (data) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const type = {
      method: 'GET',
      url: `${API_DEVICE.GET}?SiteId=${siteId}&DeviceType=${data}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(type)
      .then((response) => {
        setDevice(response.data);
      })
      .catch(() => {});
  };

  const ParameterApi = (param) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const parameter = {
      method: 'GET',
      url: `${API_PARAMETER.LIST}?SiteId=${siteId}&Device=${param}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(parameter)
      .then((response) => {
        setParameterList(response.data);
      })
      .catch(() => {});
  };

  const AssetParameterApi = (param) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const parameter = {
      method: 'POST',
      url: `/api/client/assetParameter/assetTypeParameters?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        AssetType: param
      }
    };
    axios(parameter)
      .then((response) => {
        setAssetParametersList(response.data);
      })
      .catch(() => {});
  };

const downloadApi = async (name) => {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');

  const options = {
    method: 'GET',
    url: `${TOPIC.DOWNLOAD}?SiteId=${siteId}&TopicName=${name}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  };

  try {
    const response = await axios(options);
    if (response.data && response.data.file) {
      window.open(`${IPAddress.LOCAL}${API_DOWNLOAD.DownLoads}/${response.data.file}`);
    } else {
      message.error('No file was generated. Please check the API response.');
    }
  } catch (error) {
    console.error('Error downloading file:', error);
    message.error('Failed to download the file. Please try again later.');
  }
};


  const uploadApi = async (formData) => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    let Authorization = 'Bearer ' + token;
    const getRootCauseInfo = {
      method: 'POST',
      url: `${TOPIC.UPLOAD}?SiteId=${siteId}&TopicName=${topicId}`,
      headers: {
        Authorization: Authorization
      },
      data: formData
    };
    return axios(getRootCauseInfo)
      .then((response) => {
        if (response && response.data && response.data.message) {
          message.success(response.data.message);
        }
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };

  const submitApi = async (values, url) => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    let Authorization = 'Bearer ' + token;
    const getRootCauseInfo = {
      method: 'POST',
      url: `${url}?SiteId=${siteId}`,
      headers: {
        Authorization: Authorization
      },
      data: values
    };
    return axios(getRootCauseInfo)
      .then((response) => {
        if (response && response.data && response.data.message) {
          message.success(response.data.message);
        }
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };

  const getMasterList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${TOPIC.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(Object)
      .then((response) => {
        setDatasource(response.data);
      })
      .catch(() => {});
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const devicSelection = (value) => {
    setDeviceCode(value);
    hRef.current && hRef.current.setFieldsValue({
      DeviceCode: null,
      Parameter: []
    });
    DeviceApi(value);
  };

  const assetSelection = (value) => {
    setSelectedAsset(value);
    hRef.current && hRef.current.setFieldsValue({
      Parameter: []
    });
    AssetParameterApi(value);
  };

  const deviceSelection = (value) => {
    setDeviceCode(value);
    hRef.current && hRef.current.setFieldsValue({
      Parameter: []
    });
    ParameterApi(value);
  };

  const onFinish = async () => {
    let saveObject = {};
    hRef.current && hRef.current.validateFields().then(async (values) => {
      if (selectedType && selectedType === 'Device') {
        saveObject = {
          Topic: topicId,
          Parameter: values.Parameter,
          deviceType: deviceCode,
          DeviceCode: deviceCode
        };
        await submitApi(saveObject, API_PARAMETER.UpdateTopics);
      } else {
        saveObject = {
          Topic: topicId,
          Parameter: values.Parameter,
          AssetType: selectedAsset
        };
        await submitApi(saveObject, TOPIC.UpdateAssetTopics);
      }
    });
  };

  const onFinishBulk = async () => {
    const formData = new FormData();
    formData.append('file', file);
    await uploadApi(formData);
    hForm.current && hForm.current.resetFields();
    setFile(null);
    if (hFile.current) {
      hFile.current.value = '';
    }
    hRef.current && hRef.current.setFieldsValue({
      Parameter: [],
      deviceType: null,
      DeviceCode: null
    });
    setActiveKey('List');
    setActiveDetails('1');
    setFormObjectBulk({});
  };

  // const fileBeforeUpload = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     setResultFile(e.target.result);
  //   };
  //   reader.readAsText(file);
  //   return false;
  // };

  // const handleFileChange = (info) => {
  //   let fileData = info.file.name;
  //   setFile(fileData);
  // };

  const TabChange = (activeKey) => {
    if (activeKey === 'Details') {
      setActiveKey(activeKey);
    } else if (activeKey === 'List') {
      hRef.current && hRef.current.setFieldsValue({
        Topic: null,
        deviceType: null,
        DeviceCode: null,
        Parameter: [],
        AssetType: null,
        SelectedType: null
      });
      setActiveKey(activeKey);
      setDisableDetails(true);
      setFormObject({});
      setActiveDetails('1');
      setFormObjectBulk({});
      setSelectedType(null);
    }
  };

  const handleClick = () => {
    hFile.current && hFile.current.click();
  };

  const typeChange = (value) => {
    hRef.current && hRef.current.setFieldsValue({
      deviceType: null,
      DeviceCode: null,
      Parameter: [],
      AssetType: null
    });
    setSelectedType(value);
  };

  const columns = [
    {
      title: translation('Topic'),
      dataIndex: 'Topic',
      key: 'Topic'
    },
    {
      title: translation('Action'),
      dataIndex: 'Action',
      key: 'Action',
      render: (text, record) => (
        <>
          <Tooltip placement="top" title={translation('edit')}>
            <Button type='primary' className="ant-btn" onClick={() => _editRecord(record)} >
              <EditOutlined />
            </Button>
          </Tooltip>
          <Button
            type="primary"
            onClick={(e) => {
              e.preventDefault();
              downloadApi(record.Topic);
            }}
            style={{ marginLeft: '10px' }}
            className="ant-btn"
          >
            <DownloadOutlined />
          </Button>
        </>
      )
    }
  ];

  const _editRecord = (record) => {
    if (hRef.current) {
      hRef.current.setFieldsValue(record);
    }
    setFormObject(record);
    setFormObjectBulk(record);
    setActiveKey('Details');
    setActiveDetails('1');
    setDisableDetails(false);
    setDisabledDropdown(true);
    setTopicId(record.Id);
  };

  return (
    <StyledApplication style={{ minHeight: window.innerHeight - 226 }}>
      <Tabs type="card" defaultActiveKey="List" activeKey={activeKey} onChange={TabChange}>
        <TabPane tab={translation('List')} key="List">
          <StyledTable size="small" columns={columns} dataSource={datasource} />
        </TabPane>

        <TabPane tab={translation('Details')} key="Details" disabled={disableDetails}>
          <Tabs
            tabPosition="left"
            defaultActiveKey="1"
            activeKey={activeDetails}
            onChange={(activeDetails) => {
              if (activeDetails === '2') {
                hRef.current &&
                  hRef.current.setFieldsValue({
                    deviceType: null,
                    DeviceCode: null,
                    Parameter: []
                  });
                setActiveDetails(activeDetails);
              }
              if (activeDetails === '1') {
                setActiveDetails(activeDetails);
                setFormObjectBulk({});
              }
            }}>
            <TabPane tab={translation('Manual')} key="1">
              <Form
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 12 }}
                layout="vertical"
                ref={hRef}
                name="Site_form"
                initialValues={formObject}
                onFinish={onFinish}>
                <Form.Item
                  label={translation('Topic')}
                  name="Topic"
                  rules={[{ required: true, message: translation('Please select topic !') }]}>
                  <Select disabled={disabledDropdown}>
                    <Option value="SP_MS_Operational">{translation('SP_MS_Operational')}</Option>
                    <Option value="SP_MS_Status">{translation('SP_MS_Status')}</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label={translation('Type')}
                  name="SelectedType"
                  rules={[{ required: true, message: translation('Please select Type !') }]}>
                  <Select onChange={typeChange} placeholder={translation('Please select Type')}>
                    <Option value="Asset">{translation('Asset')}</Option>
                    <Option value="Device">{translation('Device')}</Option>
                  </Select>
                </Form.Item>
                {selectedType === 'Device' && (
                  <>
                    <Form.Item
                      label={translation('DeviceType')}
                      name="deviceType"
                      rules={[
                        { required: true, message: translation('Please select deviceType !') }
                      ]}>
                      <Select
                        showSearch
                        placeholder={translation('Please select deviceType')}
                        onChange={devicSelection}>
                        {deviceType &&
                          Array.isArray(deviceType) &&
                          deviceType.map((value, index) => (
                            <Option key={index} value={value.AliasCode}>
                              {translation(value.Name)}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={translation('Device')}
                      name="DeviceCode"
                      rules={[{ required: true, message: translation('Please enter device') }]}>
                      <Select
                        showSearch
                        onChange={deviceSelection}
                        placeholder={translation('Please select device')}>
                        {device &&
                          Array.isArray(device) &&
                          device.map((value, index) => (
                            <Option key={index} value={value.DeviceCode}>
                              {translation(value.DeviceCode)}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={translation('Parameter')}
                      name="Parameter"
                      rules={[{ required: true, message: translation('Please enter parameter') }]}>
                      <Select
                        showSearch
                        mode="multiple"
                        placeholder={translation('Please select parameter')}>
                        {ParameterList.map((value, index) => (
                          <Option key={index} value={value.ParameterCode}>
                            {translation(value.ParameterDescription)}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </>
                )}
                {selectedType === 'Asset' && (
                  <>
                    <Form.Item
                      label={translation('Asset Type')}
                      name="AssetType"
                      rules={[
                        { required: true, message: translation('Please select AssetType !') }
                      ]}>
                      <Select
                        showSearch
                        placeholder={translation('Please select AssetType')}
                        onChange={assetSelection}>
                        {AssetTypeList &&
                          Array.isArray(AssetTypeList) &&
                          AssetTypeList.map((value, index) => (
                            <Option key={index} value={value.AliasCode}>
                              {translation(value.Name)}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label={translation('Parameter')}
                      name="Parameter"
                      rules={[{ required: true, message: translation('Please enter parameter') }]}>
                      <Select
                        showSearch
                        mode="multiple"
                        placeholder={translation('Please select parameter')}>
                        {AssetParametersList &&
                          Array.isArray(AssetParametersList) &&
                          AssetParametersList.map((value, index) => (
                            <Option key={index} value={value.Parameter}>
                              {translation(value.ParameterDescription)}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </>
                )}
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    {translation('Submit')}
                  </Button>
                </Form.Item>
              </Form>
            </TabPane>

            <TabPane tab={translation('Bulk')} key="2">
              <Form
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 12 }}
                layout="vertical"
                ref={hForm}
                name="Site_form"
                initialValues={formObjectBulk}
                onFinish={onFinishBulk}>
                <Form.Item
                  label={translation('Topic')}
                  name="Topic"
                  rules={[{ required: true, message: translation('Please select topic !') }]}>
                  <Select disabled={disabledDropdown}>
                    <Option value="SP_MS_Operational">{translation('SP_MS_Operational')}</Option>
                    <Option value="SP_MS_Status">{translation('SP_MS_Status')}</Option>
                  </Select>
                </Form.Item>
                <div style={{ display: 'flex' }}>
                  <Form.Item
                    name="FileUpload"
                    rules={[{ required: false, message: translation('Please upload file !') }]}>
                    <input
                      type="file"
                      ref={hFile}
                      onChange={(e) => {
                        let files = e.target.files;
                        for (const file of files) {
                          setFile(file);
                        }
                      }}
                      style={{ display: 'none' }}
                    />
                    <Button icon={<UploadOutlined />} onClick={handleClick}>
                      File Upload
                    </Button>
                  </Form.Item>
                  <Button
                    style={{ marginLeft: '20px' }}
                    onClick={() => {
                      const url = `${
                        IPAddress.LOCAL
                      }/api/sample/topics.csv?SiteId=${localStorage.get('currentSite')}`;
                      window.open(url, '_blank');
                    }}>
                    <DownloadOutlined />
                    {translation('Sample Template')}
                  </Button>
                </div>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    {translation('Submit')}
                  </Button>
                </Form.Item>
              </Form>
            </TabPane>
          </Tabs>
        </TabPane>
      </Tabs>
    </StyledApplication>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(TopicList);